import { BaseSelectorOption } from "@/types/components/selector.types";
import { Component } from "react";
import { SettingsAttribute } from "../../data/settings/SettingsAttribute";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";
import { RepeatingSelect, RepeatingSelectProps } from "./RepeatingSelect";

interface ExpiryNotificationSelectorProps
  extends
    Omit<RepeatingSelectProps<BaseSelectorOption>, "items" | "itemComparator" | "defaultItem">,
    WithLocaleProps {}

class ExpiryNotificationSelectorBase extends Component<ExpiryNotificationSelectorProps> {
  static defaultProps = {};
  constructor(props: ExpiryNotificationSelectorProps) {
    super(props);
  }

  getTranslatedNotificationPeriods() {
    const { translate } = this.props;
    const periods = SettingsAttribute.notificationPeriods;

    return {
      none: { ...periods.none, label: translate?.("notifications.none") ?? periods.none.label },
      onExpiry: {
        ...periods.onExpiry,
        label: translate?.("notifications.onExpiry") ?? periods.onExpiry.label
      },
      week: {
        ...periods.week,
        label: translate?.("notifications.oneWeekBefore") ?? periods.week.label
      },
      weeks2: {
        ...periods.weeks2,
        label: translate?.("notifications.twoWeeksBefore") ?? periods.weeks2.label
      },
      weeks3: {
        ...periods.weeks3,
        label: translate?.("notifications.threeWeeksBefore") ?? periods.weeks3.label
      },
      month: {
        ...periods.month,
        label: translate?.("notifications.oneMonthBefore") ?? periods.month.label
      },
      months2: {
        ...periods.months2,
        label: translate?.("notifications.twoMonthsBefore") ?? periods.months2.label
      },
      months3: {
        ...periods.months3,
        label: translate?.("notifications.threeMonthsBefore") ?? periods.months3.label
      }
    };
  }

  render() {
    const { theme } = this.props;
    const translatedPeriods = this.getTranslatedNotificationPeriods();

    return (
      <RepeatingSelect
        theme={theme}
        {...this.props}
        defaultItem={translatedPeriods.none}
        items={translatedPeriods}
        itemComparator={(e1, e2) => e1.index === e2.index}
      />
    );
  }
}

export const ExpiryNotificationSelector = withLocale(ExpiryNotificationSelectorBase);
